import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";
import { StatusPage } from "@/components/models/StatusPage";

export default function useStatusPages(): {
  statusPages: StatusPage[];
  isLoading: boolean;
  isError: any;
} {
  const { data, error } = useSWR(`/web_api/status_pages`, JSON_FETCHER);

  return {
    statusPages: data?.status_pages || [],
    isLoading: !(data || error),
    isError: error,
  };
}
